<!-- Navigation Controls -->
@if (showArrows()) {
  @if (canGoPrevious()) {
    <div class="nav-area nav-left" [class.visible]="showArrows()" (click)="onPreviousClick($event)">
      <div class="nav-arrow nav-arrow-left">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
  }
  @if (canGoNext()) {
    <div class="nav-area nav-right" [class.visible]="showArrows()" (click)="onNextClick($event)">
      <div class="nav-arrow nav-arrow-right">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
  }
}
<!-- Touch gesture area -->
<div (touchend)="onTouchEnd($event)"
     (touchstart)="onTouchStart($event)"
     class="nav-touch-area"></div>
